module.exports = __webpack_public_path__ + "static/img/logo.c4c9a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 204
// module chunks = 1